import type { Provider, TestResult } from "./types";
import { connectionsApi } from "@/lib/api";
import { SalesforgeIcon } from "@/components/providers/icons/SalesforgeIcon";

/**
 * Salesforge provider implementation
 */
export const salesforgeProvider: Provider = {
  id: "salesforge",
  type: "salesforge",
  name: "",
  description: "Connect to your Salesforge account to sync leads and contacts.",
  icon: SalesforgeIcon,
  configFields: [
    {
      name: "apiKey",
      label: "API Key",
      type: "password",
      required: true,
      placeholder: "Enter your Salesforge API key",
      description: "Find this in your Salesforge account settings",
    },
    {
      name: "workspace",
      label: "Workspace",
      type: "text",
      required: true,
      placeholder: "Enter your workspace name",
    },
    {
      name: "isActive",
      label: "Active",
      type: "toggle",
      required: false,
      description: "Enable or disable this connection",
    },
  ],
  validateConfig: async (config) => {
    if (!config.apiKey || !config.workspace) {
      return false;
    }
    return true;
  },
  testConnection: async (config): Promise<TestResult> => {
    try {
      const result = await connectionsApi.testConnection({
        sourceType: "salesforge",
        apiKey: config.apiKey as string,
        workspace: config.workspace as string,
        isActive: config.isActive as boolean,
        autoReply: config.autoReply as boolean,
        minReplyDelaySeconds: config.minReplyDelaySeconds as number,
        maxReplyDelaySeconds: config.maxReplyDelaySeconds as number,
      });

      return {
        success: result.success,
        message: result.message || "Connection successful",
        details: result,
      };
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : "Connection failed",
      };
    }
  },
};
